<ng-container [ngSwitch]="true">
  <label *ngIf="!isDateTime() && to.label" class="form-label">{{props["required"]?to.label+" *":to.label}}</label>
  <!-- INPUT -->
  <ng-container *ngSwitchCase="isInput()">
    <input class="form-control margin-component" [ngClass]="{ 'is-invalid': showError }" [type]="input" [placeholder]="to.placeholder"
      [formControl]="formControl" [formlyAttributes]="field" />
  </ng-container>
 
  <!-- SELECT -->
  <ng-container *ngSwitchCase="isSelect()">
    <select class="form-select margin-component" [ngClass]="{ 'is-invalid': showError }" [formControl]="formControl"
      [formlyAttributes]="field">
      <option *ngIf="to.placeholder" [ngValue]="undefined" disabled selected hidden>
        {{ to.placeholder }}
      </option>

      <ng-container *ngIf="options$ | async as opts">
        <option *ngFor="let opt of opts" [value]="opt.code">
          {{ opt.name }}
        </option>
      </ng-container>
    </select>
  </ng-container>

  <!-- DATETIME -->
  <ng-container *ngSwitchCase="isDateTime()">
    <app-datetime-field 
      [field]="field"></app-datetime-field>
  </ng-container>
<div *ngIf="showError && !isDateTime()" class="error-message margin-component">
  <formly-validation-message [field]="field"></formly-validation-message>
</div>
</ng-container>
